import { Link } from "react-router-dom";
import { MapPin, Mail, Phone, Instagram, Facebook, Twitter } from "lucide-react";
import { useApp } from "@/context/AppContext";
import Logo from "@/components/Logo";

const Footer = () => {
  const { t } = useApp();
  return (
    <footer className="bg-[#1B4332] text-[#FDFBF7] mt-24" data-testid="site-footer">
      <div className="max-w-7xl mx-auto px-6 lg:px-10 py-16 grid grid-cols-1 md:grid-cols-4 gap-10">
        <div className="md:col-span-2">
          <div className="flex items-center gap-3 mb-4">
            <Logo size={96} className="w-[80px] h-[80px] sm:w-[96px] sm:h-[96px]" />
            <div>
              <div className={`font-serif-display text-2xl ${t("brandNameFull") === "धर्मोदय सेवा संस्थान" ? "font-devanagari" : ""}`}>{t("brandNameFull")}</div>
              <div className={`text-xs uppercase tracking-[0.2em] text-[#8FBC8F] ${t("brandNameAlt") === "धर्मोदय सेवा संस्थान" ? "font-devanagari normal-case" : ""}`}>{t("brandNameAlt")}</div>
            </div>
          </div>
          <p className="text-sm italic text-[#F5B15A] mb-2">"{t("brandTagline")}"</p>
          <p className="text-sm text-[#FDFBF7]/80 max-w-md leading-relaxed">{t("footerTagline")}</p>
          <div className="flex gap-3 mt-6">
            <a href="https://www.facebook.com/share/19DGCVZjuy/" target="_blank" rel="noreferrer noopener" aria-label="Facebook" data-testid="social-facebook" className="w-9 h-9 rounded-full border border-[#FDFBF7]/25 flex items-center justify-center hover:bg-[#C95B24] hover:border-[#C95B24] transition-colors"><Facebook className="w-4 h-4" /></a>
            <a href="https://www.instagram.com/sevadharmo?igsh=MWF6bmV4Mmx3ZTZkZQ==" target="_blank" rel="noreferrer noopener" aria-label="Instagram" data-testid="social-instagram" className="w-9 h-9 rounded-full border border-[#FDFBF7]/25 flex items-center justify-center hover:bg-[#C95B24] hover:border-[#C95B24] transition-colors"><Instagram className="w-4 h-4" /></a>
            <a href="#" aria-label="Twitter" data-testid="social-twitter" className="w-9 h-9 rounded-full border border-[#FDFBF7]/25 flex items-center justify-center hover:bg-[#C95B24] hover:border-[#C95B24] transition-colors"><Twitter className="w-4 h-4" /></a>
          </div>
        </div>

        <div>
          <h4 className="text-sm uppercase tracking-[0.2em] text-[#8FBC8F] mb-4">{t("quickLinks")}</h4>
          <ul className="space-y-2 text-sm">
            <li><Link to="/about" className="hover:text-[#C95B24]">{t("about")}</Link></li>
            <li><Link to="/work" className="hover:text-[#C95B24]">{t("work")}</Link></li>
            <li><Link to="/gallery" className="hover:text-[#C95B24]">{t("gallery")}</Link></li>
            <li><Link to="/donors" className="hover:text-[#C95B24]">{t("donors")}</Link></li>
            <li><Link to="/donate" className="hover:text-[#C95B24]">{t("donate")}</Link></li>
            <li><Link to="/admin/login" className="hover:text-[#C95B24]">{t("adminLogin")}</Link></li>
          </ul>
        </div>

        <div>
          <h4 className="text-sm uppercase tracking-[0.2em] text-[#8FBC8F] mb-4">{t("reach")}</h4>
          <ul className="space-y-3 text-sm text-[#FDFBF7]/85">
            <li className="flex gap-2"><MapPin className="w-4 h-4 flex-shrink-0 mt-0.5" /> <span>276, Gali No. 2, Vijay Nagar Chauraha,<br />Etawah, Uttar Pradesh 206001, India</span></li>
            <li className="flex gap-2"><Mail className="w-4 h-4 flex-shrink-0 mt-0.5" /> <a href="mailto:Info@dharmodaysevasansthan.com" className="hover:text-[#C95B24] break-all">Info@dharmodaysevasansthan.com</a></li>
            <li className="flex gap-2"><Phone className="w-4 h-4 flex-shrink-0 mt-0.5" /> <a href="tel:+919719008009" className="hover:text-[#C95B24]">+91 97190 08009</a></li>
          </ul>
        </div>
      </div>
      <div className="border-t border-[#FDFBF7]/10">
        <div className="max-w-7xl mx-auto px-6 lg:px-10 py-5 text-xs text-[#FDFBF7]/60 flex flex-col sm:flex-row justify-between gap-2">
          <span>© {new Date().getFullYear()} Dharmoday Seva Sansthan. {t("allRights")}</span>
          <span>Made with seva.</span>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
